import React, { useEffect } from "react";
import { isEmpty } from "lodash-es";

import Text from "../../shared/text/Text";
import ZIcon from "../../shared/ZIcon/ZIcon";
import MessageTitle from "./MessageTile";

import styles from "./ClaimOwnershipModal.module.scss";

const AmountInputCardBody = ({
  body,
  state,
  setState,
  errors = {},
  disabledFields,
}) => {
  const { icon, title, subtitle, messageConfig, fields = [] } = body ?? {};

  useEffect(() => {
    setState((s) => {
      const next = { ...s };
      let changed = false;
      fields.forEach((field) => {
        if (field?.value != null && next[field.id] == null) {
          next[field.id] = field.value;
          changed = true;
        }
      });
      return changed ? next : s;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);

  const handleChange = (fieldId, value, disabled) => {
    if (disabled) return;
    setState((s) => ({
      ...s,
      [fieldId]: value === "" ? undefined : value,
    }));
  };

  return (
    <div className={styles.amountBodyWrapper}>
      {!isEmpty(messageConfig) && (
        <MessageTitle messageConfig={messageConfig} />
      )}

      <div className={styles.amountBody}>
        <div className={styles.amountHeaderCard}>
          {icon && (
            <div className={styles.amountInputIconWrapper}>
              <ZIcon unicode={icon} className={styles.selectableRowIcon} />
            </div>
          )}
          <div className={styles.selectableRowText}>
            <Text uiData={title} className={styles.selectableRowTitle} />
            <Text uiData={subtitle} className={styles.selectableRowSubtitle} />
          </div>
        </div>

        <section className={styles.amountFieldsSection}>
          {fields.map((field) => {
            const {
              id,
              label,
              inputType = "text",
              placeholder,
              disabled: fieldDisabled = false,
            } = field ?? {};
            const disabled = fieldDisabled || !!disabledFields?.has?.(id);
            const fieldError = errors[id];

            return (
              <section key={id}>
                <div className={styles.amountField}>
                  <Text uiData={label} className={styles.amountFieldLabel} />
                  <div className={styles.amountInputWrapper}>
                    <input
                      id={`amount-input-${id}`}
                      className={styles.amountInput}
                      type={inputType}
                      inputMode={inputType === "number" ? "decimal" : undefined}
                      placeholder=" "
                      value={state?.[id] ?? ""}
                      disabled={disabled}
                      onChange={(e) => handleChange(id, e.target.value, disabled)}
                    />
                    {placeholder && (
                      <span
                        className={styles.amountFieldPlaceholder}
                        aria-hidden="true"
                      >
                        {placeholder}
                      </span>
                    )}
                  </div>
                </div>
                {fieldError && (
                  <Text uiData={fieldError} className={styles.amountFieldError} />
                )}
              </section>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default AmountInputCardBody;
